import clsx from "clsx";
import { useSelector } from "react-redux";

import type { RootState } from "../../../store/store";
import type { IGameState } from "../../../store/types";
import { lowerBoundedNumber } from "../../../utils/boundNumberToRange";

type Props = {
  newGameState: IGameState;
  setNewGameState: React.Dispatch<React.SetStateAction<IGameState>>;
};

const NumberAdjuster = ({
  number,
  increment,
  decrement,
}: {
  number: number;
  increment: () => void;
  decrement: () => void;
}) => (
  <div className="flex h-[45px] w-[150px] flex-row items-center justify-around rounded">
    <button
      type="button"
      className={clsx(
        // Size
        "h-[35px] w-[35px]",
        // Layout
        "flex items-center justify-center",
        // Border
        "rounded",
        // Background
        "bg-gray-800",
        // Text
        "text-[30px] text-white",
        // States
        "hover:bg-blue",
      )}
      onClick={decrement}
    >
      <span className="-mt-1">-</span>
    </button>
    <span className="font-semibold text-xl">{number}</span>
    <button
      type="button"
      className={clsx(
        // Size
        "h-[35px] w-[35px]",
        // Layout
        "flex items-center justify-center",
        // Border
        "rounded",
        // Background
        "bg-gray-800",
        // Text
        "text-[30px] text-white",
        // States
        "hover:bg-blue",
      )}
      onClick={increment}
    >
      +
    </button>
  </div>
);

export const ScoreChanger = ({ newGameState, setNewGameState }: Props) => {
  const rosters = useSelector((state: RootState) => state.game.rosters);
  const awayTeam = rosters.away.name.slice(0, 18);
  const homeTeam = rosters.home.name.slice(0, 18);
  const { awayScore, homeScore } = newGameState;

  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center py-2.5">
        <div className="w-[35%] font-semibold text-lg">{awayTeam}</div>
        <NumberAdjuster
          number={awayScore}
          increment={() =>
            setNewGameState({
              ...newGameState,
              awayScore: awayScore + 1,
            })
          }
          decrement={() =>
            setNewGameState({
              ...newGameState,
              awayScore: lowerBoundedNumber(0, awayScore - 1),
            })
          }
        />
      </div>

      <div className="flex flex-row items-center py-2.5">
        <div className="w-[35%] font-semibold text-lg">{homeTeam}</div>
        <NumberAdjuster
          number={homeScore}
          increment={() =>
            setNewGameState({
              ...newGameState,
              homeScore: homeScore + 1,
            })
          }
          decrement={() =>
            setNewGameState({
              ...newGameState,
              homeScore: lowerBoundedNumber(0, homeScore - 1),
            })
          }
        />
      </div>
    </div>
  );
};
